import Reveal from "@/components/base/Reveal";
import { contentPrinciples, testimonials } from "@/mocks/news";

export default function VoiceSection() {
  return (
    <section id="voice" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1fr] lg:gap-16">
          <Reveal className="w-full">
            <div className="lg:sticky lg:top-32">
              <span className="label-font text-xs uppercase tracking-[0.24em] text-primary-600">
                Our Principles
              </span>
              <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
                我们怎么处理一条「料」
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                速递不是抢快，而是把依据摆清楚。下面四条是料闻社内容团队每天都在执行的标准，也是我们和大多数资讯号最大的区别。
              </p>

              <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
                {contentPrinciples.map((item) => (
                  <div
                    key={item.title}
                    className="rounded-lg border border-background-200 bg-background-50 p-4"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                      <i className={`${item.icon} text-lg`} />
                    </span>
                    <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal className="w-full" delay={80}>
            <div className="w-full">
              <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">
                读者口碑
              </h2>
              <p className="mt-2 text-sm text-foreground-600">来自订阅者的真实反馈摘录。</p>

              <div className="mt-6 space-y-4">
                {testimonials.map((item, index) => (
                  <figure
                    key={item.name}
                    className={`rounded-lg border p-4 md:p-5 ${
                      index % 2 === 0
                        ? "border-background-200 bg-background-50"
                        : "border-accent-200 bg-accent-50"
                    }`}
                  >
                    <div className="flex items-center gap-1 text-accent-500">
                      {[0, 1, 2, 3, 4].map((star) => (
                        <i key={star} className="ri-star-fill text-xs" />
                      ))}
                    </div>
                    <blockquote className="mt-2.5 text-sm leading-relaxed text-foreground-700">
                      「{item.text}」
                    </blockquote>
                    <figcaption className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-500 text-[11px] font-semibold text-background-50">
                        {item.name.slice(0, 1)}
                      </span>
                      <span className="font-medium text-foreground-800">{item.name}</span>
                      <span className="text-foreground-400">·</span>
                      <span>{item.since}</span>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}